<template>
  <div class="manager-settings">
    <div class="config-section-title">Manager Settings</div>

    <el-row :gutter="20">
      <el-col :span="6">
        <el-form-item label="Manager Function" prop="isOpen">
          <el-select v-model="config.isOpen" placeholder="Please select">
            <el-option v-for="item in yesNo" :key="item.id" :label="item.label" :value="+item.value" />
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :span="6" v-if="config.isOpen === 1">
        <el-form-item label="Password" prop="passWord">
          <el-input v-model="config.passWord" placeholder="Enter password" autocomplete="off" />
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'ManagerSettings',
  props: {
    config: { type: Object, default: () => ({}) },
    yesNo: { type: Array, default: () => [] }
  }
};
</script>

<style lang="scss" scoped>
.manager-settings {
  .config-section-title {
    height: 24px;
    line-height: 24px;
    font-size: 15px;
    font-weight: 500;
    color: #000000;
    padding-left: 10px;
    border-left: 5px solid #409eff;
    margin: 30px 0 5px 0;
    display: flex;
    align-items: center;
  }
}
</style>
